<template>
  <div class="wrapper">
    <div class="section page-header" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 text-center">
            <h1 class="title-white">{{ $t("avatar.header_title") }}</h1>
          </div>
        </div>
        <div v-if="isMobileDevice" class="md-layout margin-top-64">
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">{{ $t("common.time") }}<br />2019-2020</h4>
          </div>
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">
              {{ $t("common.role") }}<br />UI/UX Design, Strategy
            </h4>
          </div>
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">
              {{ $t("common.platform") }}<br />Mobile, Desktop, Console
            </h4>
          </div>
        </div>
        <div v-else class="md-layout margin-top-64">
          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">{{ $t("common.time") }}<br />2019-2020</h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">
                {{ $t("common.role") }}<br />UI/UX Design, Strategy
              </h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">
                {{ $t("common.platform") }}<br />Mobile, Desktop, Console
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="large-section">
        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("avatar.project.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("avatar.project.description1") }}
                </h4>
                <h4 class="content text-left">
                  {{ $t("avatar.project.description2") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div
                class="md-layout-item md-size-100 md-small-size-100 fill-in-img"
              >
                <img class="fill-in-img" :src="project" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("avatar.insights.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("avatar.insights.description1") }}
                </h4>
                <h4 class="content text-left">
                  {{ $t("avatar.insights.description2") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="insight_gif" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section" :style="visionBackgroundStyle">
        <div class="container vision-margin">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <div>
                <h3 class="description">{{ $t("avatar.vision.title") }}</h3>
                <h1 class="title-white text-left">
                  {{ $t("avatar.vision.description") }}
                </h1>
              </div>
            </div>
            <div class="md-layout-item md-size-15 md-small-size-25"></div>
            <div
              class="md-layout-item md-size-25 md-small-size-50"
              :class="{ 'mobile-img-top-margin': isMobileDevice }"
            >
              <img class="right-image-in-section" :src="vision" />
            </div>
          </div>
        </div>
      </div>

      <div class="large-section">
        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("avatar.structure.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("avatar.structure.description") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="structures[0].image" />
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="structures[1].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("avatar.editing.title") }}
                </h2>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-25 md-small-size-50">
                <img :src="editings[0].image" />
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50">
                <img :src="editings[1].image" />
              </div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="editings[2].image" />
              </div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="editings[3].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("avatar.information.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("avatar.information.description1") }}<br />
                  {{ $t("avatar.information.description2") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img
                  :src="information"
                  :large="information_large"
                  preview="0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section section-black" :style="executionBackgroundStyle">
        <div class="container excution-spcial-margin">
          <div class="md-layout">
            <div class="md-layout-item md-size-100 md-small-size-100">
              <h3 class="description">{{ $t("avatar.execution.title") }}</h3>
            </div>
            <div class="md-layout-item md-size-100 md-small-size-100">
              <h1 class="title-white text-left">
                {{ $t("avatar.execution.description") }}
              </h1>
            </div>
          </div>
          <div class="md-layout margin-top-80">
            <div class="md-layout-item md-size-23 md-small-size-50">
              <div class="gif-container">
                <img :src="execution_items[0].image" class="gif-iphone" />
                <img :src="iphone_frame" class="gif-frame" />
              </div>
            </div>
            <div class="md-layout-item md-size-10 md-small-size-0"></div>
            <div
              class="md-layout-item md-size-65 md-small-size-100"
              :class="{ 'mobile-img-top-margin': isMobileDevice }"
            >
              <div class="gif-container">
                <img :src="execution_items[1].image" class="gif-ipad" />
                <img :src="ipad_frame" class="gif-frame" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="large-section">
        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">{{ $t("avatar.result.title") }}</h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("avatar.result.description") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="results" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- main-->
  </div>
  <!-- wrapper-->
</template>

<script>
export default {
  bodyClass: "avatar-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/avatar/background.png")
    },
    project: {
      type: String,
      default: require("@/assets/img/avatar/project.png")
    },
    insight_gif: {
      type: String,
      default: require("@/assets/img/avatar/insight_gif.gif")
    },
    information: {
      type: String,
      default: require("@/assets/img/avatar/information.png")
    },
    information_large: {
      type: String,
      default: require("@/assets/img/avatar/information_large.png")
    },
    vision: {
      type: String,
      default: require("@/assets/img/avatar/vision.png")
    },
    results: {
      type: String,
      default: require("@/assets/img/avatar/results.png")
    },
    vision_background: {
      type: String,
      default: require("@/assets/img/avatar/vision_background.png")
    },
    execution_background: {
      type: String,
      default: require("@/assets/img/avatar/execution_background.png")
    },
    ipad_frame: {
      type: String,
      default: require("@/assets/img/common/ipad_frame.png")
    },
    iphone_frame: {
      type: String,
      default: require("@/assets/img/common/iphone_frame.png")
    }
  },
  data() {
    return {
      isMobileDevice: this.$isMobile,
      structures: [
        { image: require("@/assets/img/avatar/structure_1.png") },
        { image: require("@/assets/img/avatar/structure_2.png") }
      ],
      editings: [
        { image: require("@/assets/img/avatar/editing_1.png") },
        { image: require("@/assets/img/avatar/editing_2.png") },
        { image: require("@/assets/img/avatar/editing_3.png") },
        { image: require("@/assets/img/avatar/editing_4.png") }
      ],
      execution_items: [
        { image: require("@/assets/img/avatar/execution_iphone.gif") },
        { image: require("@/assets/img/avatar/execution_ipad.gif") }
      ]
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `radial-gradient(65.59% 65.59% at 50% 36.25%, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.155801) 37.2%, rgba(0, 0, 0, 0.85) 100%), linear-gradient(180deg, rgba(0, 0, 0, 0) 41.43%, rgba(0, 0, 0, 0.683021) 64.62%, #09090A 96.43%), url(${this.header})`,
        backgroundSize: `cover`
      };
    },
    visionBackgroundStyle() {
      return {
        backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),url(${this.vision_background})`,
        backgroundSize: `cover`
      };
    },
    executionBackgroundStyle() {
      return {
        backgroundImage: `url(${this.execution_background})`,
        backgroundSize: `cover`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section-at-least-height {
  min-height: 894px;
}
.conter-content-in-sction {
  vertical-align: middle;
}
.right-image-in-section {
  max-height: 666px;
}
.excution-spcial-margin {
  margin-top: 40px;
  margin-bottom: 120px;
}
.vision-margin {
  margin-top: 7rem;
  margin-bottom: 7rem;
}
</style>
